document.addEventListener('DOMContentLoaded', function() {
  /**
   * @typedef {{ container: HTMLElement; panel: HTMLElement; toggleButtons: HTMLElement[] }} PanelSetup
   */

  /** @type {PanelSetup[]} */
  const setups = Array.from(document.querySelectorAll('[data-controller="sliding-panel"]')).reduce(
    function(acc, containerNode) {
      const container = /** @type {HTMLElement} */ (containerNode);
      const panelNode = container.querySelector('[data-sliding-panel-target="panel"]');
      if (!(panelNode instanceof HTMLElement)) {
        return acc;
      }

      const toggleButtons = Array.from(
        container.querySelectorAll('[data-action*="sliding-panel#toggle"]')
      ).map(function(node) {
        return /** @type {HTMLElement} */ (node);
      });

      acc.push({
        container: container,
        panel: panelNode,
        toggleButtons: toggleButtons,
      });

      return acc;
    },
    /** @type {PanelSetup[]} */ ([]),
  );

  if (!setups.length) {
    return;
  }

  /** @param {PanelSetup} setup */
  const closePanel = function(setup) {
    setup.panel.classList.remove('active');
    setup.toggleButtons.forEach(function(btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  };

  /** @param {PanelSetup} exceptSetup */
  const closeAllPanels = function(exceptSetup) {
    setups.forEach(function(setup) {
      if (setup === exceptSetup) return;
      closePanel(setup);
    });
  };

  setups.forEach(function(setup) {
    setup.toggleButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const isOpening = !setup.panel.classList.contains('active');
        if (isOpening) {
          closeAllPanels(setup);
          setup.panel.classList.add('active');
        } else {
          setup.panel.classList.remove('active');
        }

        const isActive = setup.panel.classList.contains('active');
        setup.toggleButtons.forEach(function(btn) {
          btn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        });
      });
    });
  });

  document.addEventListener('click', function(event) {
    const target = event.target;
    if (!(target instanceof Node)) {
      return;
    }

    const clickedInside = setups.some(function(setup) {
      return setup.container.contains(target);
    });

    if (!clickedInside) {
      setups.forEach(closePanel);
    }
  });
});